import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { contactApi } from '../features/api/contactApi'
import { selectContactsWithMultiplePartnersData } from '../features/selectors/selectCommonData'

export const useContactsWithMultiplePartners = (requestId: number) => {
  const dispatch = useAppDispatch()
  const { data: contacts, meta, status } = useSelector(selectContactsWithMultiplePartnersData)

  useEffect(() => {
    if (!meta || meta.arg?.['requestId'] !== requestId) {
      dispatch(contactApi.getContactsWithMultiplePartners({ requestId }))
    }
  }, [requestId, dispatch, meta])

  return {
    contacts,
    reqWip: status === RequestStatus.PENDING,
  }
}
